import styled from "styled-components";
import { Animation } from "libs/purple-ui";

export const Svg = styled.svg`
  ${Animation.InfiniteRotateAnimation};
`;
